import {reducer as form} from 'redux-form';
import {combineReducers} from 'redux';

import users from './users';
import matches from './matches';
import routing from './routing';
import login from './login';

import {reducer as resourcerizer} from 'utils/resourcerizer';

export default combineReducers({
  users,
  matches,
  resourcerizer,
  form,
  login,
  routing
});



// WEBPACK FOOTER //
// ./src/reducers/index.js